<div *ngIf="!commonLoading">
  <crm-subproject-defaults-form
    [subprojectDefaults]="subprojectDefaults"
    [directions]="directions"
    [clients]="clients"
    (changeDefaults)="changeDefaults($event)"></crm-subproject-defaults-form>
  <div class="flex justify-content-end">
    <crm-button
      label="Отмена"
      [disabled]="loading"
      styleClass="p-button-text"
      (onClick)="ref.close()"></crm-button>
    <crm-button
      label="Заполнить"
      [disabled]="loading"
      styleClass="p-button-success"
      (onClick)="ref.close(parentId)"></crm-button>
  </div>
</div>

<crm-spinner *ngIf="commonLoading"></crm-spinner>
